export const HANDLE_GET_BICYCLE = 'handleGetBicycle';

export const HANDLE_GET_BICYCLE_FIELDS = 'handleGetBicycleFields';
